import Timer from "./Timer";

const timerContainer = document.querySelector(".timer-section span");
const timer = new Timer(timerContainer);

export { timer };
